// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ck-comment--important{border-right:3px solid #f2de02}", "",{"version":3,"sources":["webpack://./src/myCommentview.css"],"names":[],"mappings":"AAGA,uBACI,8BACJ","sourcesContent":["/* importantcomment.css */\n\n/* Yellow border for an important comment. */\n.ck-comment--important {\n    border-right: 3px solid hsl( 55, 98%, 48% );\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
